<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11Y9EV0/images/9781626569959.jpg?1697492690263" alt="This image is the cover for the book Extraordinary PR, Ordinary Budget"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Extraordinary PR, Ordinary Budget
      </h1>
      <p class="bookDescription body article font2">
        <p>Low Cost, High Impact!<br/><br/>Public relations is a make-or-break factor for all organizations, especially those that are small or mission driven. While it can be tempting to think that PR is a luxury only larger organizations can afford, PR expert Jennifer R. Farmer shows how her CCRR framework—being credible, creative, responsive, and relentless—is the silver bullet for even cash-strapped organizations. <br/><br/>Farmer emphasizes that effective public relations is in fact an essential component of organizational development—people need to know about you for your organization to have maximum impact. Her CCRR framework leverages tools everyone has access to, from social media to brand transparency, and requires attentiveness more than money. Farmer shows you that, no matter how modest your budget, you can build a cost-effective communications strategy that will help you break through the noise in an information-overloaded world.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer R Farmer
      </h2>
      
      <p class="authorDescription body article">Jennifer R. Farmer is the managing director for communications at PICO National Network. Her current and past clients, partners, and board members have been featured in leading media outlets, including the New York Times, the Wall Street Journal, the Washington Post, MSNBC, Real Time with Bill Maher, and The Rachel Maddow Show.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f59bb54e